import type { Tariff } from '../../../../api/client';

/**
 * Finds a tariff that explicitly contains an additional-generation item.
 *
 * @param tariffs Tariffs returned by the backend.
 * @returns The matching tariff or null when no matching tariff exists.
 */
export function findAdditionalGenerationTariff(
  tariffs: readonly Tariff[],
): Tariff | null {
  return (
    tariffs.find((tariff) =>
      tariff.items.some((item) => item.type === 'ADDITIONAL_GENERATION'),
    ) ?? null
  );
}

/**
 * Formats a backend money amount for the Russian UI.
 *
 * @param amount Decimal amount returned by the API.
 * @returns A localized amount with at most two fractional digits.
 */
export function formatAdditionalGenerationPrice(amount: string): string {
  const value = Number(amount);
  if (!Number.isFinite(value)) return amount;

  return value.toLocaleString('ru-RU', {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}
